import { VisibilityOff, Visibility } from "@mui/icons-material";
import { InputAdornment, IconButton, TextField } from "@mui/material";
import React from "react";
import "./styles.scss";

type PasswordFieldPropsType = {
  label: string;
  // eslint-disable-next-line no-unused-vars
  changeHandler: (event: any) => void;
  value: string;
  isValid?: boolean;
  error?: string;
  testId?: string;
};

const PasswordField = (props: PasswordFieldPropsType) => {
  const { label, changeHandler, value, error, isValid, testId } = props;
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    _event: React.MouseEvent<HTMLButtonElement>
  ) => {
    _event.preventDefault();
  };

  return (
    <TextField
      id="outlined-basic"
      inputProps={{ "data-testid": testId }}
      type={showPassword ? "text" : "password"}
      onChange={changeHandler}
      value={value}
      autoComplete="off"
      label={label}
      variant="outlined"
      error={isValid}
      helperText={error}
      fullWidth
      className="field-container"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              className="password-toggle-icon"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default PasswordField;
